import {Box} from '@mui/material';
import {useNavigate} from 'react-router';
import NavBarLogoImg from './NavBarLogoImg';
import NavBarLogoTitle from './NavBarLogoTitle';

export default function NavBarLogo() {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <Box
      data-testid="navbar-logo"
      sx={{
        display: 'flex',
        alignItems: 'center',
        mr: {xs: 2, md: 4},
        flexGrow: 1,
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.8,
        },
      }}
      onClick={handleLogoClick}
    >
      <NavBarLogoImg />
      <NavBarLogoTitle />
    </Box>
  );
}
